// extracted by mini-css-extract-plugin
export default {"chat-error":"uXtxaJN1zwERs6v","banner":"AJwpkApz_KlYPNR","icon":"MLoRgIFaHss79K0","title":"CjohiUaAGWk5Lm6","sub-title":"pBIbiqIfRowiYQT"};